import React, { useEffect, useRef } from "react";
import { RecList, RevGroup } from "./RecsDrawer";
import { colourLevel } from "./recLanes";

/*
 * "Show all" while recording or after: the full list over the band and the
 * order zone, so nothing below moves. It hangs from the band; on stacked
 * screens the Follow up block (critical row first) sits ABOVE the band, so
 * the overlay can never cover the critical row. Esc or a click outside closes
 * it and focus returns to "Show all" (the container handles both).
 */
const XIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M18 6 6 18M6 6l12 12" />
  </svg>
);

export default function RecsOverlay({ view, byKey, total, ctx, merged, maxHeight, onClose, animate }) {
  const closeRef = useRef(null);
  useEffect(() => {
    if (closeRef.current) closeRef.current.focus({ preventScroll: true });
  }, []);
  const nOpen = view.filter((k) => byKey.get(k) && byKey.get(k).status === "open").length;
  return (
    <section
      id="n3-ovl"
      className={`n3-ovl${animate ? " in" : ""}`}
      role="dialog"
      aria-label="All AI Recommendations"
      data-testid="n3-ovl"
      data-colour={colourLevel()}
      style={maxHeight ? { maxHeight: `${maxHeight}px` } : undefined}
    >
      <div className="n3-band-h">
        <span className="n3-band-lbl">AI Recommendations</span>
        <span className="n3-band-sub">{nOpen ? `${nOpen} open` : "nothing open"}</span>
        <button type="button" ref={closeRef} className="n3-band-more no-hover-tint" aria-label="Close the full list" onClick={onClose}>
          Close <XIcon />
        </button>
      </div>
      <RecList view={view} byKey={byKey} total={total} ctx={ctx} />
      {ctx.stateOk && (
        <RevGroup items={ctx.revItems(view)} open={ctx.revOpen} onToggle={ctx.onToggleRev} onUndoLast={ctx.onUndoLast} onUndo={ctx.onUndo} noteFor={ctx.noteFor} />
      )}
      <div className="n3-band-foot">
        <span className="n3-band-merged">{merged}</span>
      </div>
      {ctx.stateNote ? <div className="n3-band-note">{ctx.stateNote}</div> : null}
    </section>
  );
}
